import React from 'react';
import PropTypes from 'prop-types';

import BaseCard from '../BaseCard';

const SessionCard = props => {
    const { id, title, url, event, displayDate, onClick = () => {} } = props;

    const renderEventDetails = () => {
        if (!event && event.url && event.title) return null;
        return (
            <>
                for{' '}
                <a className="profile-co-link" href={event.url}>
                    <p className="d-inline display9 secondary mt-1 mb-0">{event?.title && event.title}</p>
                </a>
            </>
        );
    };

    return (
        <BaseCard
            cardClasses="event-card"
            id={id}
            type="session"
            title={title}
            url={url}
            onClick={onClick}
            showFavoriteIcon={false}
            imageBlock={null}
            contentBlock={
                <>
                    <a href={url} onClick={() => onClick(url)} onKeyDown={() => onClick(url)} className="card-link">
                        <div className="mt-5 mt-sm-6 mt-md-5 mt-lg-6 mb-0 mr-lg-3">
                            <span className="display9 secondary mt-4 mb-0 ">Event Session</span>
                            <h3 className="card-title d6-truncate3  display6 truncate-lines bold">{title}</h3>
                        </div>
                    </a>
                    <div className="display9 secondary mt-4 mb-0 ">{renderEventDetails()}</div>
                </>
            }
        />
    );
};

SessionCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string,
    event: PropTypes.object,
    displayDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    onClick: PropTypes.func,
};

export default SessionCard;
